module.exports = "/static/assets/6501f7ed297cb10ddd19fbb59e6dc9b9.png";